import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './Tabs.css';

class Tabs extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeTab: this.props.children[0].props.tabKey,
    };
  }

  onClickTabItem = (tab) => {
    this.setState({ activeTab: tab });
  }

  renderChildren() {
    return React.Children.map(this.props.children, child => {
      return React.cloneElement(child, {
        activeTab:this.state.activeTab,
        key:child.props.tabKey,
        tabKey:child.props.tabKey,
        label:child.props.label,
        handleClick:this.onClickTabItem
      });
    });
  }

  render() {
    const {
      props: {
        children,
      },
      state: {
        activeTab,
      }
    } = this;

    return (
      <div className="tab-container">
        <ul className="nav nav-tabs">
          {this.renderChildren()}   
        </ul>
        <div className="tab-content">
          {children.map((child) => {
            if (child.props.tabKey !== activeTab) return undefined;
            return child.props.children;
          })}
        </div>   
      </div>
    );
  }
}

Tabs.propTypes = {
  children: PropTypes.instanceOf(Array).isRequired,
}

export default Tabs;


// WEBPACK FOOTER //
// ./src/components/UI/Tabs/Tabs.js